import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getApiUrl, getImageUrl } from '../utils/api';
import './ProjectDetail.css';

function ProjectDetail() {
  const { slug } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProject();
  }, [slug]);

  const fetchProject = async () => {
    try {
      setLoading(true);
      const response = await fetch(getApiUrl(`/api/projects/${slug}`));
      if (!response.ok) {
        if (response.status === 404) {
          throw new Error('Project not found');
        }
        throw new Error('Failed to fetch project');
      }
      const data = await response.json();
      setProject(data);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching project:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-container">
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  if (!project) {
    return null;
  }

  return (
    <div className="page-container">
      <div className="project-detail">
        <h1 className="project-title">{project.title}</h1>
        
        <div className="project-image-container">
          <img 
            src={getImageUrl(project.imageUrl)}
            alt={project.title}
            className="project-image"
          />
        </div>
        
        <div className="project-description">
          <p>{project.description}</p>
        </div>
        
        {project.tags && project.tags.length > 0 && (
          <div className="project-tags">
            <span className="tags-label">Tags: </span>
            {project.tags.map((tag, index) => (
              <span key={index} className="tag">
                {tag}
                {index < project.tags.length - 1 && ', '}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ProjectDetail;
